import { styled } from '@mui/material/styles';
import HelpIcon from '@mui/icons-material/Help';
import MuiButton from '@mui/material/Button';

import { twilight, ash } from 'lib/v2/colors';
import Tooltip from 'components/v2/FormElements/Tooltip';

const StyledTooltip = styled(Tooltip)({
  float: 'right',
  marginTop: '-0.7em',
});

const StyledIcon = styled(HelpIcon)({
  color: ash,
  width: '1.25rem',
  marginTop: '-0.25rem',
  '&:hover': {
    color: twilight,
    cursor: 'help',
  },
});

const Index = ({ title }) => {
  return (
    <StyledTooltip title={title}>
      <MuiButton endIcon={<StyledIcon />}>Need Help?</MuiButton>
    </StyledTooltip>
  );
};

export default Index;
